import { Swiper, SwiperSlide } from "swiper/react"

export const Slider = ({data}: any) => {
    return (
        <>
            <div className="relative w-full"> {/* Updated container to relative for positioning */}
                <Swiper
                    navigation={{
                        nextEl: '.swiper-button-next-ex5',
                        prevEl: '.swiper-button-prev-ex5',
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        1024: {
                            slidesPerView: 1,
                            spaceBetween: 8,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 40,
                        },
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                    }}
                    className="swiper-container" // Added className for Swiper container
                >
                    {data && data?.map((item: any, i: any) => (
                        <SwiperSlide key={i}>
                            <div className="flex flex-col justify-center items-center w-full h-100">
                                <img className="w-full h-full object-cover" src={item?.url} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <button className="swiper-button-prev-ex5 grid place-content-center left-2 p-1 transition text-primary hover:text-white border border-primary hover:border-primary hover:bg-primary rounded-full absolute z-[999] top-1/2 -translate-y-1/2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 18L8 12L14 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                <button className="swiper-button-next-ex5 grid place-content-center right-2 p-1 transition text-primary hover:text-white border border-primary hover:border-primary hover:bg-primary rounded-full absolute z-[999] top-1/2 -translate-y-1/2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 6L16 12L10 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
            <div>
                {/* <Banners /> */}
            </div>
            <div>

            </div>
        </>
    )
}